/* BMF storefront interactions — no frameworks */
(function () {
  'use strict';

  // Header scroll state
  var header = document.querySelector('.bmf-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile drawer
  var toggle = document.querySelector('[data-bmf-menu-toggle]');
  var drawer = document.querySelector('[data-bmf-drawer]');
  var closeBtn = drawer ? drawer.querySelector('[data-bmf-drawer-close]') : null;
  function setDrawer(open) { if (drawer) drawer.classList.toggle('open', open); document.body.style.overflow = open ? 'hidden' : ''; }
  if (toggle && drawer) {
    toggle.addEventListener('click', function () { setDrawer(!drawer.classList.contains('open')); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
    var overlay = drawer.querySelector('.bmf-drawer__overlay');
    if (overlay) overlay.addEventListener('click', function () { setDrawer(false); });
  }

  // Scroll reveal
  var reveals = document.querySelectorAll('.bmf-reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  // FAQ accordion (content pages)
  document.querySelectorAll('[data-bmf-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.bmf-faq__item');
      if (!item) return;
      var open = item.classList.toggle('bmf-faq__item--open');
      var panel = item.querySelector('[data-bmf-faq-panel]');
      if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : null;
    });
  });
})();
